import { render, staticRenderFns } from "./DrugContentClick.vue?vue&type=template&id=4687410c&scoped=true"
import script from "./DrugContentClick.vue?vue&type=script&lang=js"
export * from "./DrugContentClick.vue?vue&type=script&lang=js"
import style0 from "./DrugContentClick.vue?vue&type=style&index=0&id=4687410c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4687410c",
  null
  
)

export default component.exports